<section>
  <span *ngIf="filterValidateMessage" class="filter-validate-message">{{orderLblText.filterInfoMsgLbl}}</span>
  <form [formGroup]="filterOrderHeaderForm" >
    <div class="row filter-order-header-div" >
      <div class="form-group filter-order-header-start-date">
        <label class="lbl" [for]="effectiveFromLBL">{{orderLblText.startDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker formControlName="startDate" class="kendoInput" name="effectiveFrom"
                          placeholder="MM/DD/YYYY"
                          #effectiveFromLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
        </kendo-datepicker>
      </div>
      <div class="form-group filter-order-header-start-date">
        <label class="lbl" [for]="effectiveToLBL">{{orderLblText.endDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker formControlName="endDate" class="kendoInput" name="effectiveTo"
                          placeholder="MM/DD/YYYY"
                          #effectiveToLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
        </kendo-datepicker>
      </div>
      <div class="form-group">
        <button kendoButton [disabled]="filterSaveInProcess" class="btn dialogBtnSize filter-date-btn"
                (click)="getFilterOrderHeader()">
          {{orderLblText.filterButtonLbl}}<kendo-loader *ngIf="filterSaveInProcess" style="color:blue"></kendo-loader>
        </button>
      </div>
    </div>
  </form>    
</section>
<section>
  <kendo-grid [data]="orderHeaderGridData"
              class="orderSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="orderGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="orderGridstate.take"
              [skip]="orderGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="orderHeaderGridSortChange($event)"
              (pageChange)="orderHeaderGridPageChange($event)"
              (dataStateChange)="orderHeaderGridDataStateChange($event)"
              [filter]="orderGridSettings.state.filter"
              [loading]="orderLoading">
    <!--(columnReorder)="onReorder($event)"
  (columnVisibilityChange)="onVisibilityChange($event)"-->

    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
          {{orderLblText.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
          {{orderLblText.exportToPDFLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
    </ng-template>
    <kendo-grid-column *ngFor="let col of orderGridSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'sampleProductOrderNumber'">
        <a class="link sample-product-order-number" [routerLink]="['sample-request-admin/sample-request-order-history2/order-details']"
           (click)="proceedToSampleProductDetails(dataItem)">
          {{dataItem.sampleProductOrderNumber}}
        </a>
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'cost'">
        {{dataItem.cost | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'createdDate'">
        <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="createdDate">
        </app-grid-daterange-filter>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
    <!--[data]="data"-->
    <kendo-excelexport [collapsible]="true" fileName="SampleProductOrderHeader.xlsx" #excelexport>
      <kendo-excelexport-column field="sampleProductOrderNumber" title="Order Number" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="customerNumber" title="Customer" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="createdDate" title="Order Date" [width]="250">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="requester" title="Requester" [width]="250">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="requesterEmail" title="Requester Email" [width]="250">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="firstName" title="Contact" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="cost" title="Cost" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="region" title="Region" [width]="150">
      </kendo-excelexport-column>
    </kendo-excelexport>

  </kendo-grid>

</section>


